/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react/prop-types */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import ContactsSlider from 'pricing-pages-unified-ui/components/common/ContactsSlider';
import ContactsInfoBox from 'pricing-pages-unified-ui/components/common/info-box/ContactsInfoBox';
import ContactsMaxLimitContainer from 'pricing-pages-unified-ui/components/common/info-box/ContactsMaxLimitContainer';
import { minPurchasableContactsSelector } from 'pricing-pages-unified-ui/selectors/ContactsSelectors';
import { activeCurrencySelector } from 'pricing-pages-unified-ui/selectors/CurrencySelectors';
import { calculatedPriceForProductConfigurationsInListSelector } from 'pricing-pages-unified-ui/selectors/PricingSelectors';
import { calculateAdditionalUnitsForTierSwitch, getMaxAdditionalUnits, getQuantityPackSteppingFunction } from 'pricing-pages-unified-ui/utils/merchandiseUtils';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ENTERPRISE, PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import H5 from 'UIComponents/elements/headings/H5';
import Small from 'UIComponents/elements/Small';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UILink from 'UIComponents/link/UILink';
import UITile from 'UIComponents/tile/UITile';
import { CALCULATOR } from '../../constants/Tracking';
import { hasHigherProductLevelInProductInventorySelector, hasProductInProductInventorySelector, productsFromProductInventoryQuantityPackQuantitySelector } from '../../selectors/ProductInventorySelectors';
import { currentSkuIdForProductSelector, productSelector, productVersionSelector, skuSelector } from '../../selectors/ProductsSelectors';
import { AsyncContactsPriceBreakdownModal } from './contacts-price-breakdown/AsyncContactsPriceBreakdownModal';
const TTS_CONTACT_LIMIT = 500000;

const StyledSliderWrapper = (_ref) => {
  let {
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/_jsx(ContactsSlider, Object.assign({
    numberInputClassName: className
  }, rest));
};

const StyledInlineTitle = styled(FormattedMessage).withConfig({
  displayName: "ContactsSliderContainer__StyledInlineTitle",
  componentId: "sc-1bsx6ut-0"
})(["font-weight:500;"]);
const StyledSlider = styled(StyledSliderWrapper).withConfig({
  displayName: "ContactsSliderContainer__StyledSlider",
  componentId: "sc-1bsx6ut-1"
})(["font-size:14px !important;max-width:100px;"]);
const CompactDescriptionText = styled.div.withConfig({
  displayName: "ContactsSliderContainer__CompactDescriptionText",
  componentId: "sc-1bsx6ut-2"
})(["line-height:2;max-width:320px;font-size:12px;margin:0 auto;margin-top:8px;"]);
const StyledStepperInput = styled(UIStepperInput).withConfig({
  displayName: "ContactsSliderContainer__StyledStepperInput",
  componentId: "sc-1bsx6ut-3"
})(["display:inline-flex !important;max-width:100px;margin-right:8px;input{font-size:12px;height:34px;}"]);

const ContactsSliderDescription = ({
  additionalContacts,
  quantityPackSkuId,
  productConfigurations,
  compact = false,
  trackingSource,
  queryParamTerm
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const {
    quantityUnit: {
      includedWithQuantityPack,
      includedWithProductVersion
    }
  } = useSelector(state => skuSelector(state, {
    skuId: quantityPackSkuId
  }));
  const [priceBreakdownVisible, setPriceBreakdownVisible] = useState(false);
  useEffect(() => {
    if (priceBreakdownVisible) {
      getUsageTracker().track('clickToViewModal', {
        name: 'contact-picker-more-details-modal',
        location: trackingSource
      });
    }
  }, [priceBreakdownVisible]);
  const startingPriceForContacts = useSelector(state => calculatedPriceForProductConfigurationsInListSelector(state, {
    allProductConfigurations: productConfigurations,
    productConfigurations: [createProductConfig({
      skuId: quantityPackSkuId
    })],
    queryParamTerm
  })).monthly.calculatedPrice;
  const TextWrapper = compact ? CompactDescriptionText : Small;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [priceBreakdownVisible && /*#__PURE__*/_jsx(AsyncContactsPriceBreakdownModal, {
      quantityPackSkuId: quantityPackSkuId,
      marketingContactsSelected: additionalContacts + includedWithProductVersion,
      handleModalClose: () => setPriceBreakdownVisible(false),
      productConfigurations: productConfigurations,
      queryParamTerm: queryParamTerm
    }), /*#__PURE__*/_jsx(TextWrapper, {
      className: "flex-column",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketingContactsBeta.contactsSlider.description_jsx",
        elements: {
          QuantityMultiplier: () => /*#__PURE__*/_jsx(FormattedNumber, {
            value: includedWithQuantityPack
          }),
          IncludedAdditionalUnits: () => /*#__PURE__*/_jsx(FormattedNumber, {
            value: includedWithProductVersion
          }),
          Price: () => /*#__PURE__*/_jsx(FormattedCurrency, {
            value: startingPriceForContacts,
            currencyCode: currencyCode
          }),
          Link: ({
            children
          }) => /*#__PURE__*/_jsx(UILink, {
            onClick: () => setPriceBreakdownVisible(true),
            onMouseEnter: () => AsyncContactsPriceBreakdownModal.preload(),
            children: children
          })
        }
      })
    })]
  });
};

const ContactsSliderContainer = ({
  quantityPackSkuId,
  quantityPackQuantity,
  onChange,
  productConfigurations,
  setProductLevel,
  compact = false,
  trackingSource = CALCULATOR,
  queryParamTerm
}) => {
  const quantityPack = useSelector(state => skuSelector(state, {
    skuId: quantityPackSkuId
  }));
  const {
    quantityUnit: {
      includedWithQuantityPack,
      includedWithProductVersion,
      unitType
    },
    productId
  } = quantityPack;
  const {
    apiName,
    productLine,
    productLevel
  } = useSelector(state => productSelector(state, {
    productId
  }));
  const minPurchasableContacts = useSelector(state => minPurchasableContactsSelector(state, {
    quantityPackSkuId
  })) || 0;
  const ownedQuantityPackQuantity = useSelector(state => productsFromProductInventoryQuantityPackQuantitySelector(state, {
    productIdentifier: {
      apiName
    },
    unitType
  }));
  const ownsProduct = useSelector(state => hasProductInProductInventorySelector(state, {
    productAttributeFilters: {
      productLine,
      productLevel
    }
  }));
  const ownedUnitQuantity = ownsProduct ? includedWithProductVersion + ownedQuantityPackQuantity : 0;
  const ownsHigherProductLevel = useSelector(state => hasHigherProductLevelInProductInventorySelector(state, {
    productLine: MARKETING,
    productLevel
  }));
  const maxAdditionalUnits = getMaxAdditionalUnits(quantityPack);
  const maxContactsInPlan = maxAdditionalUnits + includedWithProductVersion;
  const steppingFunction = getQuantityPackSteppingFunction(quantityPack);
  useEffect(() => {
    if (quantityPackQuantity < minPurchasableContacts && !ownsHigherProductLevel) {
      onChange(steppingFunction(minPurchasableContacts));
    } else if (steppingFunction(quantityPackQuantity) !== quantityPackQuantity) {
      onChange(steppingFunction(quantityPackQuantity));
    }
  }, [quantityPackQuantity, minPurchasableContacts]);
  const enterpriseQuantityPack = useSelector(state => {
    const {
      quantityUnit: {
        limitName
      }
    } = quantityPack;
    const skuId = currentSkuIdForProductSelector(state, {
      productLine: MARKETING,
      productLevel: ENTERPRISE
    });
    const {
      quantityPackDetails: enterpriseQuantityPackDetails
    } = productVersionSelector(state, {
      skuId
    });
    return enterpriseQuantityPackDetails.find(({
      quantityUnit: {
        limitName: searchLimitName
      }
    }) => limitName === searchLimitName);
  });

  const handleSwitchToEnterprise = () => {
    setProductLevel(ENTERPRISE);
    const newMarketingUnits = calculateAdditionalUnitsForTierSwitch(quantityPackQuantity, quantityPack, enterpriseQuantityPack);
    const enterpriseSteppingFunction = getQuantityPackSteppingFunction(enterpriseQuantityPack);
    onChange(enterpriseSteppingFunction(newMarketingUnits), enterpriseQuantityPack.skuId);
  };

  const minUnitsToDisplay = ownsHigherProductLevel ? includedWithProductVersion : includedWithProductVersion + minPurchasableContacts;

  const handleContactsChange = (newValue, roundUp) => {
    const additionalUnitQuantity = steppingFunction(newValue - includedWithProductVersion, roundUp);
    getUsageTracker().track('additionalUnitsPicker', {
      trackingSource,
      unitType,
      productLine,
      productLevel,
      ownsProduct,
      skuId: quantityPackSkuId,
      ownedUnitQuantity,
      displayedUnitQuantity: includedWithProductVersion + additionalUnitQuantity
    });
    onChange(additionalUnitQuantity);
  };

  if (compact) {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx(StyledStepperInput, {
          stepSize: includedWithQuantityPack,
          value: steppingFunction(quantityPackQuantity) + includedWithProductVersion,
          min: minUnitsToDisplay,
          max: maxContactsInPlan,
          onChange: event => handleContactsChange(event.target.value, true)
        }), /*#__PURE__*/_jsx(StyledInlineTitle, {
          message: "marketingContactsBeta.marketingContacts"
        })]
      }), /*#__PURE__*/_jsx(ContactsSliderDescription, {
        queryParamTerm: queryParamTerm,
        quantityPackSkuId: quantityPackSkuId,
        additionalContacts: quantityPackQuantity,
        productConfigurations: productConfigurations,
        compact: true,
        trackingSource: trackingSource
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledSlider, {
        value: steppingFunction(quantityPackQuantity) + includedWithProductVersion,
        min: minUnitsToDisplay,
        trackStart: includedWithProductVersion,
        max: maxContactsInPlan,
        step: includedWithQuantityPack,
        labelsBelowSlider: true,
        onChange: handleContactsChange,
        title: /*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketingContactsBeta.marketingContacts"
          })
        }),
        description: /*#__PURE__*/_jsx(ContactsSliderDescription, {
          queryParamTerm: queryParamTerm,
          quantityPackSkuId: quantityPackSkuId,
          additionalContacts: quantityPackQuantity,
          productConfigurations: productConfigurations,
          trackingSource: trackingSource
        })
      }), setProductLevel && productLevel === PROFESSIONAL && /*#__PURE__*/_jsx(ContactsInfoBox, {
        titleKey: "pricingPage.contactsPicker.pricingTip.title",
        content: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "pricingPage.contactsPicker.pricingTip.marketingProTip_jsx",
          elements: {
            UILink
          },
          options: {
            onClick: handleSwitchToEnterprise
          }
        }),
        showBox: quantityPackQuantity + includedWithProductVersion >= maxContactsInPlan
      }), productLevel === ENTERPRISE && /*#__PURE__*/_jsx(ContactsInfoBox, {
        titleKey: "pricingPage.contactsPicker.upperLimitTip.title",
        content: /*#__PURE__*/_jsx(ContactsMaxLimitContainer, {}),
        showBox: quantityPackQuantity + includedWithProductVersion >= TTS_CONTACT_LIMIT
      }), /*#__PURE__*/_jsx(UITile, {
        className: "p-all-3 m-top-4",
        children: /*#__PURE__*/_jsx(Small, {
          className: "justify-center text-center",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "marketingContactsBeta.contactsSlider.incluesFreeContacts"
          })
        })
      })]
    });
  }
};

ContactsSliderContainer.propTypes = {
  use: PropTypes.oneOf(['slider', 'stepper'])
};
export default ContactsSliderContainer;